/* Un battement commun aux bandeaux qui balayent.
 *
 * LE PROBLÈME. Le bandeau d'annonce et le bandeau de chiffres changent tous les deux de
 * couleur toutes les six secondes, chacun avec son propre minuteur lancé au chargement.
 * Comme ils ne s'activent pas à la même milliseconde — l'un attend une réponse du CRM,
 * l'autre attend d'entrer dans l'écran — ils partent décalés et le restent. Pire, un
 * setInterval dérive : l'écart grandit au fil de la page.
 *
 * LA SOLUTION. On ne compte pas le temps écoulé depuis le chargement, on lit l'horloge.
 * Le rang courant se déduit de l'heure elle-même, et le prochain pas est calé sur la
 * prochaine frontière. Deux bandeaux démarrés à dix secondes d'écart tombent donc sur le
 * même rang, et y restent — il n'y a rien à synchroniser entre eux, ils lisent la même
 * horloge. Un onglet laissé en arrière-plan puis rouvert se recale tout seul.
 */
window.SSBattement = {
  // Rang courant dans un cycle de `n` pas de `duree` secondes.
  rang: function (duree, n) {
    var pas = Math.max(1, duree) * 1000;
    if (!n || n < 1) return 0;
    return Math.floor(Date.now() / pas) % n;
  },

  // Millisecondes avant la prochaine frontière.
  attente: function (duree) {
    var pas = Math.max(1, duree) * 1000;
    return pas - (Date.now() % pas);
  },

  // Appelle `fn` à chaque frontière, sans dérive : on recalcule l'attente à chaque fois
  // plutôt que de faire confiance à un intervalle fixe.
  caler: function (duree, fn) {
    var self = this;
    var arret = false;
    function prochain() {
      if (arret) return;
      setTimeout(function () {
        if (arret) return;
        try {
          fn();
        } catch (e) {
          /* un bandeau qui échoue n'arrête pas l'autre */
        }
        prochain();
        // Vingt-cinq millisecondes APRÈS la frontière, et non pile dessus : un minuteur
        // qui se réveille une milliseconde trop tôt lirait encore le rang précédent, et
        // le bandeau resterait un cran en arrière pour le reste de la page.
      }, self.attente(duree) + 25);
    }
    prochain();
    return function () {
      arret = true;
    };
  },
};
